let apiHost = 'http://localhost:21022';
let staticHost = 'http://localhost:21022';
let wsHost = "localhost:21022";
if (process.env.NODE_ENV === 'production') {
	apiHost = 'https://api.vavaha.com';
	staticHost = 'https://static.vavaha.com';
	wsHost = "api.vavaha.com";
}
let isWebView = (window.chrome && window.chrome.webview != null);

export default {
	version: 0.1,
	apiHost: apiHost,
	wsHost: wsHost,
	imgUrlHost: staticHost,
	isWebView:isWebView,
	uploadAction: apiHost + "/api/file/OnPostUpload",
	uploadVideoAct: apiHost + "/api/file/OnUploadVideo",
	uploadFile: apiHost + "/api/file/OnUploadFile",
	notImage: staticHost + "/images/no-image.jpg",
	faceImage: staticHost + "/images/default-img.png",
	dashboard: ''
}
